"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _client = require("@apollo/client");

var _default = function _default(query, params) {
  var entry = (0, _client.useQuery)(query, params);
  return (0, _react.useMemo)(function () {
    return entry;
  }, [JSON.stringify(params), !!(entry === null || entry === void 0 ? void 0 : entry.loading), !!(entry === null || entry === void 0 ? void 0 : entry.error), JSON.stringify(entry === null || entry === void 0 ? void 0 : entry.data)]);
};

exports["default"] = _default;